export function InitializeChargebee() {
  var siteAttribute = "oapps";
  var locationHref = window.location.origin;
  if (
    locationHref.indexOf("jupiter.rekzyl.com") !== -1 ||
    locationHref.indexOf("localhost") !== -1 ||
    locationHref.indexOf("client2.rekzyl.com") !== -1 ||
    locationHref.indexOf("client3.rekzyl.com") !== -1 ||
    locationHref.indexOf("client4.rekzyl.com") !== -1 ||
    locationHref.indexOf("client5.rekzyl.com") !== -1 ||
    locationHref.indexOf("client6.rekzyl.com") !== -1 ||
    locationHref.indexOf("pre-omessage.oapps.xyz") !== -1
  ) {
    siteAttribute = "oapps-test";
  }
  window.Chargebee.init({ site: siteAttribute });
  return { siteAttribute, locationHref };
}
export function RegisterChargebee(accountType, appProperties, setAppProperties, setSuccessModal = () => {}) {
  let isSuccessCheckoutVariable = false;
  if (window.Chargebee !== undefined && window.Chargebee !== null) {
    window.Chargebee.registerAgain();
  }

  var cbInstance = window.Chargebee.getInstance();

  var cart = cbInstance.getCart();

  cart.setCustomer({
    cf_oapps_id: appProperties.osyncId,
    cf_leftserviceid: appProperties.leftServiceId,
    cf_accounttype: accountType,
    cf_servicename: appProperties.service,
    cf_license: accountType,
  });
  cbInstance.setCheckoutCallbacks(function (cart) {
    // you can define a custom callbacks based on cart object

    return {
      loaded: function () {},
      close: function () {
        if (isSuccessCheckoutVariable) {
          setSuccessModal(true);
          if (typeof appProperties?.fetchData === "function") {
          appProperties
            .fetchData(
              "omni/license?leftServiceId=" + appProperties.leftServiceId + "&osyncId=" + appProperties.osyncId,
              "GET",
              null,
              appProperties
            )
            .then((response) => {
            const responseData = JSON.parse(response);
            let updatedLicenseObj = {
              ...appProperties.licenseObj,
              ...responseData.data,
            };
            setAppProperties({
              ...appProperties,
              licenseObj: updatedLicenseObj,
            });
          });
          }
        }
      },
      success: function (hostedPageId) {
        // appProperties.fetchData("chargebee/license/add?hostedPageId=" + hostedPageId, "POST", null, appProperties).then(function (response) {
        //   response = JSON.parse(response);
        //   console.log("sucess Chargeebee :>>>>>>", response);
        //   let updatedLicenseObj = {
        //     ...appProperties.licenseObj,
        //     licenseDetails: response.data,
        //   };
        //   setAppProperties({
        //     ...appProperties,
        //     licenseObj: updatedLicenseObj,
        //   });
        // });
        isSuccessCheckoutVariable = true;
      },
      step: function (value) {
        if (value === "thankyou_screen") {
          // setIsSuccessCheckout(true);
        }
      },
    };
  });
}
